function addItemToCart(formID) {
  var self     = this;
  var form     = document.querySelector("#".concat(formID));
  var formData = serialize(form, { hash: true });

  window.fetch("/cart/add.js", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    })
    .then(function (response) {
      if (response.ok) {
        updateCartAJAX();
      }
    })
    .catch(function (error) {
      throw new Error(error);
    });
}

document.body.addEventListener( 'click', function ( e ) {
  if( e.target && e.target.classList.contains('js-add-to-cart') ) {
    e.preventDefault();
    var formID = e.target.parentNode.getAttribute("id");
    addItemToCart(formID);
  };
});